import Clipboard from 'clipboard'
import { Toast } from 'vant'
export default {
  install (Vue) {
    Vue.directive('copy', {
      bind: (el, binding, vnode) => {
        el.setAttribute('data-clipboard-action', 'copy')
        el.setAttribute('data-clipboard-target', '.copy--dom')
        const copyDom = document.createElement('div')
        copyDom.innerHTML = binding.value.textCopy
        document.body.appendChild(copyDom)
        copyDom.className = 'copy--dom'
        copyDom.style.position = 'absolute'
        copyDom.style.top = '-1000px'
        /* eslint-disable no-new */
        new Clipboard(el)
        el.addEventListener('click', () => {
          binding.value.callback()
          Toast('复制成功')
          // setTimeout(() => {
          //   document.body.removeChild(document.getElementsByClassName('copy--dom')[0])
          // }, 500)
        }, true)
      }
    })
  }
}
